/**
 * Portal Manta · LEIS_FEDERAIS_BR
 * Extraído de App.jsx v29.3 (via AST)
 */
const LEIS_FEDERAIS_BR = {
  '8666_1993':'Lei de Licitações (revogada pela 14.133/2021)',
  '8987_1995':'Lei das Concessões',
  '11079_2004':'Lei das PPPs',
  '14133_2021':'Nova Lei de Licitações',
  '10257_2001':'Estatuto da Cidade',
  '12462_2011':'RDC - Regime Diferenciado de Contratações',
  '13334_2016':'Programa de Parcerias de Investimentos (PPI)',
  '9503_1997':'Código de Trânsito Brasileiro',
  '6766_1979':'Parcelamento do solo urbano',
  '12651_2012':'Código Florestal',
  '9605_1998':'Lei de Crimes Ambientais',
  '10406_2002':'Código Civil',
  '13146_2015':'Estatuto da Pessoa com Deficiência',
  '13303_2016':'Lei das Estatais',
};

export { LEIS_FEDERAIS_BR };
export default LEIS_FEDERAIS_BR;
